var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 10C1.75 9.72757 1.76323 9.458 1.78912 9.19194L3.28207 9.33723C3.26087 9.55508 3.25 9.77616 3.25 10C3.25 13.7279 6.27208 16.75 10 16.75C13.7279 16.75 16.75 13.7279 16.75 10C16.75 6.27208 13.7279 3.25 10 3.25C9.77616 3.25 9.55508 3.26087 9.33723 3.28207L9.19194 1.78912C9.458 1.76323 9.72756 1.75 10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10ZM7.60466 2.10332C7.08249 2.26152 6.5823 2.47003 6.10978 2.72312L6.81801 4.04539C7.20439 3.83844 7.61311 3.66809 8.03959 3.53888L7.60466 2.10332ZM4.76586 3.62271C4.34857 3.96556 3.96556 4.34857 3.62271 4.76586L4.78169 5.7181C5.06252 5.37629 5.37629 5.06253 5.7181 4.78169L4.76586 3.62271ZM2.72312 6.10978C2.47003 6.5823 2.26152 7.08249 2.10332 7.60466L3.53888 8.03959C3.66809 7.61312 3.83844 7.2044 4.04539 6.81801L2.72312 6.10978ZM8.83335 6.25V10.8333V11.1299L9.0362 11.3463L11.5362 14.0129L12.6305 12.987L10.3333 10.5367V6.25H8.83335Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.5b412bd943260b48e41631fbbbeaf3a4.svg";
export { ForwardRef as ReactComponent };